<template>
  <div class="details-component" v-if="isLandlord()">
    <div class="details-component__header">
      <h1 v-if="isNew">{{ $t('pricingrules.new_rule') }}</h1>
      <h1 v-else>{{ $t('pricingrules.edit_rule') }}</h1>
    </div>
    <div class="details-component__content content pricingrulesform">
      <form class="form" @submit.prevent>
        <fieldset class="form__fieldset--nice-margin">
          <legend>{{ $t('pricingrules.purchase_start_time') }}</legend>
          <div class="form__field form__field_checkboxlist">
            <div class="form__label">{{ $t('pricingrules.weekday') }}</div>
            <div class="form__field weekdays">
              <template v-for="day in weekdays">
                <label class="form__label">
                      <input type="checkbox"  name="weekdays" v-model="checkedWeekdays" v-bind:id="day" v-bind:value="day" class="form__fieldset__checkbox" >
                      <span class="form__fieldset__custom-checkbox"></span>
                      <label v-bind:for="day" class="form__label">{{ $t('pricingrules.weekdays.' + day) }}</label>
                  </label>
              </template>
            </div>
          </div>
          <div class="d-flex">
            <div class="form__field form__field_datepicker" :class="{'form__field_error' : errors.has('startMinutes')}">
              <label class="form__label">{{ $t('pricingrules.start_minutes')}}</label>
              <el-time-select
                placeholder=""
                v-model="startMinutes"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }">
              </el-time-select>
            </div>
            <div class="form__field form__field_datepicker" :class="{'form__field_error' : errors.has('endMinutes')}">
              <label class="form__label">{{ $t('pricingrules.end_minutes')}}</label>
              <el-time-select
                placeholder=""
                v-model="endMinutes"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                  minTime: startMinutes
                }">
              </el-time-select>
            </div>
          </div>

          </fieldset>
          <fieldset class="form__fieldset--nice-margin">
            <legend>{{ $t('pricingrules.rules_validity_period') }}</legend>

            <div class="d-flex">
              <div class="form__field form__field_datepicker" :class="{'form__field_error' : errors.has('startDate') || errors.has('startDateTime')}">
                <label class="form__label">{{ $t('pricingrules.start_date_time')}}</label>
                <el-date-picker
                    v-model="form.startDate"
                    format="dd.MM.yyyy HH:mm"
                    type="datetime"
                    name="startDate"
                    :picker-options="startTimeOptions"
                    >
                  </el-date-picker>
              </div>
              <div class="form__field form__field_datepicker" :class="{'form__field_error' : errors.has('endDate') || errors.has('endDateTime')}">
                <label class="form__label">{{ $t('pricingrules.end_date_time')}}</label>
                <el-date-picker
                    v-model="form.endDate"
                    format="dd.MM.yyyy HH:mm"
                    type="datetime"
                    name="endDate"
                    :picker-options="endTimeOptions"
                    >
                  </el-date-picker>
              </div>
            </div>
          </fieldset>

          <fieldset class="form__fieldset--nice-margin">
            <legend>{{ $t('pricingrules.price_restrictions') }}</legend>
            <div class="form__field form__field_textbox" :class="{'form__field_error' : errors.has('startingPrice')}" >
              <label for="startingPrice" class="form__label">{{ $t('pricingrules.starting_price') }}</label>
              <input type="text" class="form__input"
                  name="startingPrice"
                  id="startingPrice"
                  v-model="form.startingPrice"
                  v-validate data-vv-rules="stepsOrStartingPriceRequiredValidator"
                  data-vv-as="$t('pricingrules.starting_price')"
                  data-vv-delay="1000" />
              <span class="price"> {{currency_short}}{{ $t('pricingrules.curr_per_parking') }}</span>
              <tooltip v-show="errors.has('startingPrice:stepsOrStartingPriceRequiredValidator')" class="form__validation">{{ $t('errors.starting_price_or_steps_required') }}</tooltip>
            </div>

            <!--<div class="form__field form__field_textbox" :class="{'form__field_error' : errors.has('minPrice')}" >
              <label for="minPrice" class="form__label">{{ $t('pricingrules.min_price') }}</label>
              <input type="number" class="form__input" name="minPrice" id="minPrice" value=""
               v-model="form.minPrice" v-validate data-vv-rules="decimal:2|min:1"
                data-vv-as="$t('pricingrules.mi_price')" data-vv-delay="1000" /> <span class="price"> {{ $t('pricingrules.curr_per_parking') }}</span>
            </div>-->

            <div class="form__field form__field_textbox" :class="{'form__field_error' : errors.has('maxPrice')}" >
              <label for="maxPrice" class="form__label">{{ $t('pricingrules.max_price') }}</label>
              <input type="text" class="form__input" name="maxPrice" id="maxPrice" value=""
               v-model="form.maxPrice" v-validate="'decimal:2'"
                data-vv-as="$t('pricingrules.max_price')" data-vv-delay="1000" /> <span class="price"> {{currency_short}}{{ $t('pricingrules.curr_per_parking') }}</span>
                <tooltip v-show="errors.has('maxPrice')" class="form__validation">{{ $t('errors.field_numeric') }}</tooltip>
            </div>
          </fieldset>
          <fieldset class="form__fieldset--nice-margin">
            <legend>{{ $t('pricingrules.maximum_duration') }}</legend>
            <!-- <switch-checkbox
              class="checkbox"
              :text="$t('pricingrules.combined_parking_limitation')"
              :onChange="toggleCombinedParking"
              :checked="isCombinedParking"
            /> -->
            <div v-model="maxDuration" class="center-content" v-show="isCombinedParking !== true">
              <div class="d-flex flex-column">
                <div class="form__field" :class="{'form__field_error' : errors.has('maxMinutes')}">
                  <label class="form__label" style="margin-left: 15px;">
                  <label v-bind:for="sdf" class="form__label">
                    <input
                      type="checkbox"
                      name="ch_maxMinutes"
                      class="form__fieldset__checkbox"
                      v-bind:checked="ch_maxMinutes ? 'checked' : ''"
                      v-on:click="() => {
                        ch_maxMinutes = !ch_maxMinutes;
                      }"
                    />

                    <span class="form__fieldset__custom-checkbox" style="height: 34px; margin-right: 5px;"></span>
                    {{ $t('pricingrules.by_max_minutes') }}
                  </label>
                  </label>
                  <InputBoxes
                    v-model="form.maxMinutes"
                    inputFrom="right"
                    treatAs="datetimeinput"
                    v-validate="'maxMinutesValidator'" data-vv-value-path="form.maxMinutes" data-vv-name="maxMinutes"
                    :disabled="!ch_maxMinutes"
                    :maxDays="999">
                  </InputBoxes>
                  <tooltip v-show="errors.has('maxMinutes')" class="form__validation">{{ $t('errors.duration_by_max_minutes_required') }}</tooltip>
                </div>
                <div class="form__field form__field--nowrap" :class="{'form__field_error' : errors.has('maxTime')}">
                  <label class="form__label" style="margin-left: 15px;">
                  <label v-bind:for="sdf" class="form__label" style="white-space: nowrap; ">
                    <input
                      type="checkbox"
                      name="ch_maxTime"
                      class="form__fieldset__checkbox"
                      v-bind:checked="ch_maxTime ? 'checked' : ''"
                      v-on:click="() => { ch_maxTime = !ch_maxTime; }"
                    >
                    <span class="form__fieldset__custom-checkbox" style="height: 34px; margin-right: 5px;"></span>
                    {{ $t('pricingrules.by_max_time') }}
                  </label>
                  </label>
                  <el-time-select
                    v-model="form.maxTime"
                    :disabled="!ch_maxTime"
                    name="maxTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:01',
                      end: '23:59'
                    }"
                    style="max-width: 125px;"
                  >
                  </el-time-select>
                  <label class="form__label" style="margin-left: 15px;">
                    <label v-bind:for="by_next_day" class="form__label" >{{ $t('pricingrules.by_next_day') }}:
                      <input
                        type="checkbox"
                        name="max_time_next_day"
                        v-bind:checked="(form.max_time_next_day && ch_maxTime) ? 'checked' : form.max_time_next_day = false "
                        v-on:click="() => { form.max_time_next_day = !form.max_time_next_day; }"
                        class="form__fieldset__checkbox"
                        :disabled="!ch_maxTime"
                      >
                      <span class="form__fieldset__custom-checkbox" style="height: 34px; margin-left: 5px;"></span>
                    </label>
                  </label>
                </div>
              </div>
            </div>

            <div class="center-content" v-show="isCombinedParking === true">
              <div class="d-flex flex-column">
                <label for="maxMinutes" class="form__label">{{ $t('pricingrules.by_max_minutes') }}</label>
                <InputBoxes
                  v-model="form.maxMinutes"
                  inputFrom="right"
                  treatAs="datetimeinput"
                  v-validate="'maxMinutesValidator'" data-vv-value-path="form.maxMinutes" data-vv-name="maxMinutes"
                  :maxDays="999">
                </InputBoxes>
                <tooltip v-show="errors.has('maxMinutes')" class="form__validation">{{ $t('errors.duration_by_max_minutes_required') }}</tooltip>
              </div>
              <div class="form__field form__field--nowrap" :class="{'form__field_error' : errors.has('maxTime')}">
                <label for="maxTime" class="form__label">{{ $t('pricingrules.by_max_time') }}</label>
                <el-time-select
                  v-model="form.maxTime"
                  name="maxTime"
                  :picker-options="{
                    start: '00:00',
                    step: '00:01',
                    end: '23:59'
                  }"
                >
                </el-time-select>
                <label class="form__label" style="margin-left: 15px;">
                  <label v-bind:for="day" class="form__label" >{{ $t('pricingrules.by_next_day') }}
                    <input
                      type="checkbox"
                      name="max_time_next_day"
                      v-model="form.max_time_next_day"
                      v-bind:checked="(max_time_next_day && maxDuration === 'maxTime') ? 'checked' : ''"
                      class="form__fieldset__checkbox"
                      :disabled="maxDuration != 'maxTime'"
                    >
                    <span class="form__fieldset__custom-checkbox" style="height: 34px; margin-left: 5px;"></span>
                  </label>
                </label>
              </div>
            </div>

          <h3 class="section">{{ $t('pricingrules.steps') }}</h3>
          <div class="form__field">
            <table class="table pricingsteps" ref="pricingStepsTable">
              <tr v-for="(row, index) in stepRows">
                <td>
                  <span class="form__label">{{ $t('pricingrules.every_started')}}:</span>
                  <InputBoxes
                    v-model="row.step"
                    v-bind:value="row.step"
                    inputFrom="right"
                    treatAs="datetimeinput">
                    ref="stepInputBox"
                  </InputBoxes>
                </td>
                <td>
                  <span class="form__label">{{ $t('pricingrules.after')}} </span>
                  <InputBoxes
                    v-model="row.after"
                    v-bind:value="row.after"
                    inputFrom="right"
                    treatAs="datetimeinput">
                    ref="afterInputBox"
                  </InputBoxes>
                </td>
                <td><span class="form__label">{{ $t('pricingrules.price')}} </span>
                  <input type="number" class="form__input" v-model="row.price" name="price">
                  <span class="price"> {{currency_short}}</span>
                </td>
                <td>
                  <a class="link link--orange" @click="removeRow(index)">{{ $t('common.remove') }}
                    <i class="icon icon--cross"></i>
                  </a>
                </td>
                <input type="hidden" v-model="row.unit" name="unit">
                <input type="hidden" v-model="row.after_unit" name="after_unit">
              </tr>
            </table>
          </div>
          <div>
              <a @click.prevent.stop="addRow" class="link">{{ $t('pricingrules.add') }}
                <i class="icon icon--plus"></i>
              </a>
          </div>

       </fieldset>

        <div class="form__buttons buttonset">
          <router-link :to="{ name: 'product', params: { id: $route.params.id }}" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <button type="submit" class="buttonset__button btn btn--main" v-on:click.prevent.stop="onSubmit()">
          {{ $t('common.save') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import Tooltip from 'common/Tooltip';
  import InputBoxes from 'common/InputBoxes';
  import SwitchCheckbox from 'common/SwitchCheckbox';

  export default {
    components: {
      Tooltip,
      InputBoxes,
      SwitchCheckbox,
    },
    computed: {
      isNew() {
        return !this.$route.params.ruleId;
      },
      ...mapGetters({
        pricingrule: 'pricingrules/pricingrule/pricingrule',
        user: 'user/user/user',
      }),
    },
    created() {
      this.$validator.remove('maxMinutesValidator');
      this.$validator.remove('stepsOrStartingPriceRequiredValidator');
      this.$validator.installDateTimeValidators(moment);
      this.createStepsOrStartingPriceRequiredValidator();
      this.createMaxMinutesValidator();
      this.productId = this.$route.params.id;
      if (!this.isLandlord()) {
        this.$router.push({ name: 'product', params: { id: this.productId } });
      }
      if (!this.isNew) {
        this.fetchPricingRule();
      } else {
        this.checkedWeekdays = this.weekdays;
      }
    },
    methods: {
      getLanguage() {
        return this.$i18n.locale;
      },
      changeStartMinutes(eventData) {
        this.startMinutes.HH = eventData.data.HH;
        this.startMinutes.mm = eventData.data.mm;
      },
      changeEndMinutes(eventData) {
        this.endMinutes.HH = eventData.data.HH;
        this.endMinutes.mm = eventData.data.mm;
      },
      changeStartDateTime(eventData) {
        this.startDateTime.HH = eventData.data.HH;
        this.startDateTime.mm = eventData.data.mm;
      },
      changeEndDateTime(eventData) {
        this.endDateTime.HH = eventData.data.HH;
        this.endDateTime.mm = eventData.data.mm;
      },
      removeStartDate() {
        this.startDate = null;
        this.form.startDate = null;
        this.startDateTime = {
          HH: '',
          mm: '',
        };
      },
      removeEndDate() {
        this.endDate = null;
        this.form.endDate = null;
        this.endDateTime = {
          HH: '',
          mm: '',
        };
      },
      onInputChange(ev) {
        console.log('aa', ev);
      },
      addRow() {
        this.stepRows.push({ step: 0, after: 0, price: 0 });
      },
      removeRow(row) {
        this.$delete(this.stepRows, row);
      },
      fetchPricingRule() {
        this.$store.dispatch('pricingrules/pricingrule/fetch', { productId: this.productId, ruleId: this.$route.params.ruleId, user: this.user }).then(() => {
          this.form = this.pricingrule;
          if (this.pricingrule.steps.length > 0) {
            this.stepRows.splice(0, 1);
          }
          this.pricingrule.steps.forEach((el) => {
            el.prices.forEach((price) => {
              this.stepRows.push({
                step: el.step,
                after: price.after,
                price: price.price,
                unit: el.unit,
                after_unit: price.unit,
              });
            });
          });
          this.checkedWeekdays = this.pricingrule.weekdays;
          if (this.pricingrule.startDate) {
            this.startDate = moment(this.pricingrule.startDate).toDate();
            this.startDateTime = this.getTimeFromDate(this.pricingrule.startDate);
          }
          if (this.pricingrule.endDate) {
            this.endDate = moment(this.pricingrule.endDate).toDate();
            this.endDateTime = this.getTimeFromDate(this.pricingrule.endDate);
          }
          if (this.pricingrule.startMinutes !== 0) {
            this.startMinutes = this.calcMinutesToTime(this.pricingrule.startMinutes);
          }
          if (this.pricingrule.endMinutes !== 1439) {
            this.endMinutes = this.calcMinutesToTime(this.pricingrule.endMinutes);
          }
          if (this.pricingrule.maxMinutes) {
            this.ch_maxMinutes = true;
          }
          if (this.pricingrule.maxTime) {
            this.ch_maxTime = true;
            if (this.pricingrule.max_time_next_day) {
              this.max_time_next_day = true;
            }
          } else {
            this.max_time_next_day = false;
          }
        });
      },
      onSubmit() {
        this.$validator.validateAll({
          startingPrice: 'stepsOrStartingPriceRequiredValidator',
          maxMinutes: 'maxMinutesValidator',
        })
          .then((success) => {
            if (!success) {
              return;
            }
            if (this.checkedWeekdays.length > 0) {
              this.form.weekdays = this.checkedWeekdays;
            }
            if (this.startMinutes) {
              this.form.startMinutes = this.calcMinutesFromTime(this.startMinutes);
            } else {
              this.form.startMinutes = 0;
            }
            if (this.endMinutes) {
              const endMinutesFromTime = this.calcMinutesFromTime(this.endMinutes);
              this.form.endMinutes = endMinutesFromTime > 0 ? endMinutesFromTime : 1439;
            } else {
              this.form.endMinutes = 1439;
            }
            this.form.startDate = this.getTimeFormatForSave(this.form.startDate);
            this.form.endDate = this.getTimeFormatForSave(this.form.endDate);
            if (this.stepRows) {
              this.stepRows.forEach((el, index) => {
                this.stepRows[index].price = parseFloat(el.price);
                if (el.step === 0 || !el.step) {
                  this.stepRows.splice(index, 1);
                } else {
                  const i = this.addedSteps.findIndex(obj => obj.step === el.step);
                  if (i !== -1) {
                    this.addedSteps[i].prices.push(
                      { after: el.after,
                        price: el.price,
                        unit: 'minute',
                      });
                  } else {
                    this.addedSteps.push(
                      { step: el.step,
                        unit: 'minute',
                        prices: [{
                          after: el.after,
                          price: el.price,
                          unit: 'minute',
                        }],
                      },
                    );
                  }
                }
              });
              this.form.steps = this.addedSteps;
            }
            this.form.productId = this.productId;
            if (!this.form.startingPrice) {
              this.form.startingPrice = 0;
            }
            if (!this.ch_maxMinutes) {
              this.form.maxMinutes = '';
            }
            if (!this.ch_maxTime) {
              this.form.maxTime = '';
              this.form.max_time_next_day = false;
            }
            this.$store.dispatch('pricingrules/pricingrule/save', { user: this.user, rule: this.form }).then(() => {
              this.form = {};
              this.$router.push({ name: 'product', params: { id: this.productId } });
            });
          })
          .catch(() => {});
      },
      calcMinutesFromTime(time) {
        const splitTime = time.split(':');
        return (splitTime[0] * 60) + parseInt(splitTime[1], 10);
      },
      addTimeToDate(date, time) {
        return moment(date).hour(time.HH).minutes(time.mm).format('YYYY-MM-DD HH:mm:ss');
      },
      calcMinutesToTime(time) {
        const hours = Math.floor(time / 60);
        const h = `0${hours}`;
        const minutes = time - (hours * 60);
        const min = `0${minutes}`;
        return `${h.substr(-2)}:${min.substr(-2)}`;
      },
      getTimeFromDate(date) {
        const hours = moment(date).hour();
        const h = `0${hours}`;
        const minutes = moment(date).minutes();
        const min = `0${minutes}`;
        return { HH: h.substr(-2), mm: min.substr(-2) };
      },
      createStepsOrStartingPriceRequiredValidator() {
        this.$validator.extend('stepsOrStartingPriceRequiredValidator', {
          getMessage: () => 'Steps or starting price must be set',
          validate: () => (this.form.startingPrice >= 0 ? true :
            this.stepRows.length > 0 && this.stepRows[0].step > 0),
        });
      },
      createMaxMinutesValidator() {
        this.$validator.extend('maxMinutesValidator', {
          getMessage: () => 'Max minutes must be set',
          validate: () => (this.ch_maxMinutes === false ? true : this.form.maxMinutes > 0),
        });
      },
      getTimeFormatForSave(date) {
        if (date && date !== '') {
          return moment(date).format('YYYY-MM-DD HH:mm');
        }
        return null;
      },
      toggleCombinedParking(isChecked) {
        this.isCombinedParking = isChecked;
      },
    },
    data() {
      return {
        currency: process.env.CURRENCY,
        currency_short: process.env.CURRENCY_SHORT,
        form: {
          startingPrice: 0,
          startMinutes: '00:00',
          endMinutes: '23:59',
          startDate: null,
          endDate: null,
          maxMinutes: 1440,
          max_time_next_day: false,
        },
        max_time_next_day: false,
        startMinutes: '00:00',
        endMinutes: '23:59',
        maxDuration: 'maxMinutes',
        productId: null,
        ch_maxMinutes: false,
        ch_maxTime: false,
        startTimeOptions: {
          disabledDate: (date) => {
            const isInPast = moment(date).isBefore(moment(), 'day');
            if (this.form.endDate) {
              return moment(this.form.endDate).isBefore(moment(date), 'day') || isInPast;
            }
            return isInPast;
          },
          firstDayOfWeek: 1,
        },
        endTimeOptions: {
          disabledDate: (date) => {
            const isInPast = moment(date).isBefore(moment(), 'day');
            if (this.form.startDate) {
              return moment(this.form.startDate).isAfter(moment(date), 'day') || isInPast;
            }
            return isInPast;
          },
          firstDayOfWeek: 1,
        },
        checkedWeekdays: [],
        weekdays: [0, 1, 2, 3, 4, 5, 6],
        stepRows: [{
          step: 0,
          after: 0,
          price: 0,
          unit: '',
        }],
        addedSteps: [],
        state: {
          date: new Date(),
          highlighted: {
            dates: [
              new Date(),
            ],
          },
          disabled: {
            to: new Date(Date.now() - (24 * 60 * 60 * 1000)),
          },
        },
        startTime: {},
        endTime: {},
        isCombinedParking: false,
      };
    },
  };
</script>
<style lang="scss">
  .pricingrulesform .datepicker {
    flex: none;
    margin-right: 20px;
  }
  .pricingrulesform .time-picker {
    input.display-time {
      height: 100% !important;
      font-weight: 700;
      border: none !important;
      border-bottom: 1px solid #cfd4d8 !important;
      font-size: 14px !important;
      transition: all 225ms ease-in-out;
      flex: 2;
      width: 50% !important;
      max-width: 60px;
      padding: 0 !important;
    }
    .clear-btn {
      display: initial !important;
      position: initial !important;
    }
    .form__field {
      margin-bottom: 10px;
    }
  }
  .pricingrulesform .form__input {
    max-width: 180px;
  }
  .pricingsteps .form__input {
    padding-top: 0;
  }
  .pricingsteps td {
    height: 38px;
  }
  .weekdays label {
    width: 80px;
  }

  .center-content {

    .form__field {
      align-items: center;

      @media screen and (max-width: 400px) {
        align-items: flex-start;
      }

      .form__label {
        display: flex;
        align-items: center;

      }

    }

    .input-boxes-wrapper {

      @media screen and (max-width: 400px) {
        display: block !important;
        padding-top: 10px;
      }

    }

  }

  .input-boxes-contents {

    margin-right: 30px;

    @media screen and (max-width: 500px) {
      margin-right: 0;
    }

  }

  .table.pricingsteps {

    .input-boxes-wrapper {

      @media screen and (max-width: 1200px) {
        padding-top: 10px;
        display: block;
      }

    }

    .form__input {

      @media screen and (max-width: 1200px) {
        height: 38px;
        width: 50px;
      }

    }

    td {

      @media screen and (max-width: 800px) {
        padding-top: 20px;
      }

    }

    tr:first-child {

      td:first-child {

        @media screen and (max-width: 800px) {
          padding-top: 0;
        }

      }

    }

    td {

      @media screen and (max-width: 800px) {
        display: block;
        height: auto;
      }

    }


    tr:not(:last-child) {

      td {

        @media screen and (min-width: 801px) and (max-width: 1200px) {
          padding-bottom: 30px;
        }

      }

    }

  }

  .center-radio-button {
    display: flex;
    align-items: center;

    .el-radio__label {
      white-space: pre-wrap;
      word-break: break-word;
    }

  }

.center-radio-button {
  width: max-content;
}

</style>

<style lang="scss" scoped>
 .checkbox {
   margin-top: 10px;

   @media screen and (min-width: 1371px) {
     margin-bottom: 20px;
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/pricingrules/AddPricingRuleView.vue